import { FormHeader, FormSection, CheckboxContainer, CheckboxLabel, ReminderDaysInput, ErrorMessage } from './styles';
import { CheckboxMark, Checkbox } from 'components/Checkbox/Checkbox';

export default function CandidateSettings({
  letCandidateSeeScore,
  setLetCandidateSeeScore,
  reminderEmail,
  setReminderEmail,
  reminderEmailDays,
  setReminderEmailDays,
  deductCredits,
  setDeductCredits,
  userIsSuperAdmin,
  automatedEmail,
  setAutomatedEmail,
  maxReminderEmailInDays,
}) {
  return (
    <FormSection>
      <FormHeader id="customizeSettingsSection">Candidate settings:</FormHeader>
      <Checkbox
        checked={!!automatedEmail}
        label="Send automated email about test to candidate"
        onChange={() => setAutomatedEmail(!automatedEmail)}
      />
      <Checkbox
        checked={!!letCandidateSeeScore}
        label="Let candidate see the test score afterwards"
        onChange={() => setLetCandidateSeeScore(!letCandidateSeeScore)}
      />
      {userIsSuperAdmin && (
        <Checkbox
          checked={!!deductCredits}
          label="Deduct credits (Super-Admin Only)"
          onChange={() => setDeductCredits(!deductCredits)}
        />
      )}
      <CheckboxContainer>
        <CheckboxMark checked={!!reminderEmail} onChange={() => setReminderEmail(!reminderEmail)} />
        <CheckboxLabel
          fontSize="15px"
          onClick={() => {
            setReminderEmail(!reminderEmail);
          }}
        >
          Send reminder email in
          <ReminderDaysInput
            value={reminderEmailDays}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => setReminderEmailDays(e.target.value)}
          ></ReminderDaysInput>
          days
        </CheckboxLabel>
      </CheckboxContainer>
      {automatedEmail &&
        (!reminderEmailDays || reminderEmailDays < 1 || reminderEmailDays > maxReminderEmailInDays) && (
          <ErrorMessage>Please select a day between 1 - {maxReminderEmailInDays}</ErrorMessage>
        )}
    </FormSection>
  );
}
